import { useParams } from 'react-router-dom';
import { ReplyEditor } from '@/features/wizard-magic-email';

/** Edit one reply: its words and information, next steps, and the email as it will look. `/wizard/magic-email/library/:entryId`. */
export function WizardMagicEmailEntryPage() {
  const { entryId = '' } = useParams<{ entryId: string }>();

  return (
    <main className="min-h-full bg-[#F7F7F8] px-4 pt-5 pb-12 sm:px-6 lg:px-10">
      <ReplyEditor key={entryId} entryId={entryId} />
    </main>
  );
}
